import React, { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Building2, CalendarDays, Wallet } from "lucide-react";

const fmtBRL = (v) => `R$ ${Number(v || 0).toLocaleString("pt-BR", { minimumFractionDigits: 2 })}`;

const fmtPeriodo = (p) => {
  if (!p) return "";
  const [ano, mes, q] = p.split("-");
  if (q === "1" || q === "2") return `${q}ª quinzena de ${mes}/${ano}`;
  return `${mes}/${ano}`;
};

export default function ExtratoMontadora() {
  const [extrato, setExtrato] = useState(null);

  useEffect(() => {
    api.get("/montadora/extrato")
      .then(r => setExtrato(r.data))
      .catch(e => toast.error(formatApiError(e)));
  }, []);

  return (
    <div className="p-8 max-w-5xl" data-testid="extrato-montadora-page">
      <div className="mb-6">
        <div className="label-cap">Financeiro · Montadora</div>
        <h1 className="font-heading font-extrabold text-3xl tracking-tighter mt-1">A Receber por Empresa</h1>
        <p className="text-sm text-muted-foreground mt-2">
          Quanto sua montadora tem a receber de cada empresa e a data do próximo pagamento, conforme o calendário de cada uma.
        </p>
      </div>

      {extrato && (
        <div className="border-2 border-[#142766] bg-[#142766]/5 p-5 mb-6 flex items-center gap-4" data-testid="em-total">
          <Wallet className="w-8 h-8 text-[#142766]" />
          <div>
            <div className="label-cap">Total a receber</div>
            <div className="font-heading font-extrabold text-3xl text-[#142766]">{fmtBRL(extrato.total_a_receber)}</div>
            <div className="text-xs text-muted-foreground">Período atual: {fmtPeriodo(extrato.periodo)}</div>
          </div>
        </div>
      )}

      {extrato?.empresas?.length === 0 && (
        <div className="border border-border bg-white p-12 text-center text-muted-foreground" data-testid="em-vazio">
          Nenhum valor pendente de recebimento no momento.
        </div>
      )}

      <div className="grid md:grid-cols-2 gap-4">
        {extrato?.empresas?.map(e => (
          <div key={e.empresa_id} className="border border-border bg-white p-5" data-testid={`em-card-${e.empresa_id}`}>
            <div className="flex items-center gap-2 mb-3">
              <Building2 size={16} className="text-[#142766]" />
              <span className="font-heading font-bold">{e.empresa_nome}</span>
            </div>
            <div className="flex items-end justify-between gap-3">
              <div>
                <div className="label-cap">A receber</div>
                <div className="font-mono font-bold text-2xl text-[#00A859]">{fmtBRL(e.a_receber)}</div>
                <div className="text-xs text-muted-foreground">{e.servicos} serviço(s) pendente(s) · {fmtBRL(e.periodo_atual)} no período atual</div>
              </div>
              <div className="text-right shrink-0">
                <div className="label-cap flex items-center gap-1 justify-end whitespace-nowrap"><CalendarDays size={11} /> Próx. pagamento</div>
                <div className="font-semibold text-sm">
                  {e.proximo_pagamento
                    ? new Date(e.proximo_pagamento + "T12:00:00").toLocaleDateString("pt-BR")
                    : "A definir"}
                </div>
                {e.periodicidade && (
                  <div className="text-[11px] text-muted-foreground capitalize">{e.periodicidade} · {e.forma_pagamento || "PIX"}</div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
